import React from 'react';
import { PRICING } from './pricing';
import StorageIcon from '@mui/icons-material/Storage';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PsychologyIcon from '@mui/icons-material/Psychology';

export const TRACKS = {
  completeInterviewKit: {
    title: "Complete Interview Kit",
    description: "Master React, JS internals, Angular, and UI system design.",
    icon: <DashboardIcon sx={{ fontSize: 48 }} />,
    categories: ['javascript', 'react', 'angular', 'frontendSystemDesign', 'interviewPrep'],
    color: '#3b82f6'
  },
  frontend: {
    title: "Frontend Engineering Mastery",
    description: "Master React, JS internals, Angular, and UI system design.",
    icon: <DashboardIcon sx={{ fontSize: 48 }} />,
    categories: ['foundation', 'completeInterviewKit', 'dsa'],
    color: '#3b82f6',
    price: PRICING.frontend?.price || 999,
    mrp: PRICING.frontend?.mrp || 4999
  },
  backend: {
    title: "Backend Engineering & Architecture",
    description: "Scalable architectures, databases, and distributed systems.",
    icon: <StorageIcon sx={{ fontSize: 48 }} />,
    categories: ['dsa', 'systemDesign'],
    color: '#10b981',
    price: PRICING.backend?.price || 999,
    mrp: PRICING.backend?.mrp || 4999
  },
  ai: {
    title: "AI Track",
    description: "From neural network basics to AI Agent engineering.",
    icon: <PsychologyIcon sx={{ fontSize: 48 }} />,
    categories: ['aiInterviewPrep', 'mentorship'],
    color: '#eab308',
    price: PRICING.ai?.price || 999,
    mrp: PRICING.ai?.mrp || 4999
  }
};
